<template>
  <div class="drag-container">

    <h2 v-if="title">{{title}}</h2><br />

<!--
    <el-collapse accordion v-model="help">
      <el-collapse-item name="help">
        <template slot="title">
          <span class="text-info">Help&nbsp;<i class="header-icon fa fa-info-circle"></i></span>
       </template>
       You can drag items from list to list, just&nbsp;<i class="fa fa-mouse-pointer">&nbsp;</i>drag and item, from list to list.
      </el-collapse-item>
    </el-collapse>
-->

    <ul class="drag-list">

      <li v-for="stage in stages" class="drag-column" :class="{['drag-column-' + stage]: true}" :key="stage">

        <span class="drag-column-header">
          <slot :name="stage">
            <b style="color: ivory;">{{ formatStage(stage) }}</b>
          </slot>
        </span>

        <div class="drag-options"></div>

        <ul class="drag-inner-list" ref="list" :data-status="stage">

          <li class="drag-item" v-for="(card,index) in this.localBlocks" :data-block-id="card.id" :key="index">

            <slot :name="card.id">
              <kanban-card :v-model="card" />
            </slot>
          </li>
        </ul>
        <div class="drag-column-footer">
          <slot :name="`footer-${stage}`"></slot>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import FormattingMixins from '@/mixins/FormattingMixins'

import KanbanCard from '@/components/atoms/KanbanCard'

export default {
  name: 'kanban-board',

  mixins: [FormattingMixins],

  components: {
    KanbanCard
  },

  props: {

    value: {
      required: true
    },

    title: {
      type: String,
      default: null
    },

    stages: {
      type: Array,
      default: function () {
        return ['pending', 'on-hold', 'needs-review', 'in-progress', 'approved']
      },
    },

  },

  methods: {
    init () {
/*
      dragula(this.$refs.list)
      .on('drag', (el) => {
        el.classList.add('is-moving')
      })
      .on('drop', (block, list) => {
        let index = 0
        for (index = 0; index < list.children.length; index += 1) {
          if (list.children[index].classList.contains('is-moving')) break
        }
        this.$emit('update-block', block.dataset.blockId, list.dataset.status, index)
      })
      .on('dragend', (el) => {
        el.classList.remove('is-moving')
        window.setTimeout(() => {
          el.classList.add('is-moved')
          window.setTimeout(() => {
            el.classList.remove('is-moved')
          }, 600)
        }, 100)
      })
*/
    },

    formatStage (text) {
      return this.titleCase(this.removeSpecialChars(text))
    },

  },

  computed: {
    localBlocks: function () {
      return this.blocks
    }
  },


  data () {
    return {
      blocks: this.value,
      statuses: this.defaultStatus,
    }
  },

  created () {
//    console.log('value', this.value, 'localBlocks', this.localBlocks)
  }
}

</script>

<style lang="scss" scoped>
  @import '../../assets/css/kanban.scss';

  $pending: #606266;
  $on-hold: #FB7D44;
  $needs-review: #E6A23C;
  $approved: #67C23A;
  $completed: #FB7D44;
  $in-progress: #409EFF;
  * {
    box-sizing: border-box;
  }
  body {
    background: #33363D;
    color: white;
    font-family: 'Raleway';
    font-weight: 300;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }
  .drag-column {
    .drag-column-header > div {
      width: 100%;
      h2 > a {
        float: right;
      }
    }
    .drag-column-footer > div {
        margin-left: 10px;
        a {
            text-decoration: none;
            color: white;
            &:hover {
                text-decoration: underline;
            }
        }
    }
    &-pending {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $pending;
      }
    }
    &-on-hold {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $on-hold;
      }
    }
    &-in-progress {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $in-progress;
      }
    }
    &-needs-review {
      .drag-column-header,
      .is-moved,
      .drag-options{
        background: $needs-review;
      }
    }
    &-completed {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $completed;
      }
    }
    &-approved {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $approved;
      }
    }
  }
  .section {
    padding: 20px;
    text-align: center;
    a {
      color: white;
      text-decoration: none;
      font-weight: 300;
    }
    h4 {
      font-weight: 400;
      a {
        font-weight: 600;
      }
    }
  }
</style>
